import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Layout = ({ children, title, description }) => {
  useEffect(() => {
    document.title = title ? `${title} · Ranger Base` : "Ranger Base · Guardians of a Changing Country";
    if (description) setMeta("description", description);
  }, [title, description]);

  return (
    <div className="min-h-screen bg-warmwhite text-charcoal font-body antialiased">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;

// Reusable overline label
export const Overline = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-2 text-[11px] tracking-overline uppercase ${className}`}>
    <span className="h-px w-6 bg-current opacity-40" />
    {children}
  </span>
);
